import React from 'react';
import styles from '../../styles/effects/RainEffect.module.scss';

interface RainEffectProps {
  isDay?: boolean;
}

const RainEffect: React.FC<RainEffectProps> = ({ isDay }) => {
  const drops = Array.from({ length: 100 }).map((_, i) => {
    const left = Math.random() * 100;
    const duration = 0.5 + Math.random() * 5;
    const delay = -Math.random() * 1;

    return (
      <div
        key={i}
        className={styles.drop}
        style={{
          left: `${left}%`,
          animationDuration: `${duration}s`,
          animationDelay: `${delay}s`,
        }}
      />
    );
  });

  return <div className={`${styles.rain} ${isDay ? styles.day : styles.night}`}>{drops}</div>;
};

export default RainEffect;
